import {observable} from 'mobx';
import User from './User';
import Addition from './Addition';
import Logo from '~/assets/images/logo_default.svg';

class Organization {
  id = null;

  name;

  industry;

  address;

  email;

  @observable
  admin = new User();

  @observable addition = new Addition();

  constructor(store, id) {
    this.id = id;
  }

  updateFromJson(json) {
    this.name = json.name;
    this.industry = json.industry;
    this.address = json.address;
    if (json.admin) {
      this.admin.id = json.admin.id;
      this.admin.name = json.admin.name;
      this.admin.nickName = json.admin.nickName;
      this.admin.phone = json.admin.phone;
      this.admin.email = json.admin.email;
      this.admin.domain = json.admin.domain;
    }
    if (json.addition) {
      this.addition.logo = json.addition.logo || Logo;
    }
  }
}

export default Organization;
